import { createContext, useContext } from "react";
import { Admin } from "services/admin/auth/types";
import { Actions } from "./types";

export type AuthContextType = [Admin | undefined, (action: Actions) => void];

export const AuthContext = createContext<AuthContextType | null>(null);

// Narrower alternative to useStore() for consumers that only need `auth`
// + dispatch — re-renders only when the auth slice changes, not on every
// settings/langs/references update. Backed by the same StoreProvider reducer.
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within StoreProvider");
  }
  return context;
};
